// extracted by mini-css-extract-plugin
var _1 = "NavButtonIcon-module__icon--B3lCq";
export { _1 as "icon" }
